import { BaseDRNService } from '@traveloka/district-fetcher';
import { DRNUtil } from '@traveloka/district-util';
import noOp from 'common/utils/noOp';

export default class BaseService extends BaseDRNService {
  // web can use network debugger instead polluting console logs
  logger = DRNUtil.isWeb() ? noOp : DRNUtil.log;

  timeout = 120000;

  handleError(config, error) {
    throw error;
  }
}
